import styled from 'styled-components';

export const CompanyDataContainer = styled.div.attrs({})`
  display: flex;
  gap: 20px;
  width: 100%;

  /* usados apenas quando o modal tem altura fixa */
  ${(props) => (props.$body ? `flex: 1; min-height: 0;` : ``)}
  ${(props) => (props.$auto ? `flex-shrink: 0;` : ``)}
`;

export const CloseContainer = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.palette.colors.shadow};
  padding-bottom: 12px;
`;

// Titulo e o resumo do registro dividem a mesma linha: o resumo e contexto do
// cabecalho, nao conteudo, e por isso nao consome altura da area rolavel.
export const TituloArea = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1;
  min-width: 0;

  /* Em tela estreita nao ha largura para os dois lado a lado: o resumo desce
     para baixo do titulo em vez de espremer os dois. */
  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const HeaderExtra = styled.div.attrs({})`
  flex: 1;
  min-width: 0;
  padding-left: 20px;
  border-left: 1px solid ${(props) => props.theme.palette.colors.shadow};

  /* Empilhado, a divisoria vertical nao separa mais nada. */
  @media (max-width: 900px) {
    padding-left: 0;
    border-left: none;
  }
`;

export const ContainerColumn = styled.div.attrs({})`
  flex: 1;
  /* :not(:last-child) e nao :first-child — com uma coluna so nao ha divisoria */
  &:not(:last-child) {
    border-right: 1px solid ${(props) => props.theme.palette.colors.shadow};
    padding-right: 20px;
  }

  /* com altura fixa a coluna vira um flex container: o titulo fica parado e o
     conteudo abaixo dele recebe a rolagem. */
  ${(props) =>
    props.$fill
      ? `display: flex; flex-direction: column; min-height: 0; min-width: 0;`
      : ``}
`;

export const ColumnContent = styled.div.attrs({})`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;
